// extracted by mini-css-extract-plugin
export var cardIcon = "_az-4";
export var checkboxCard = "_az-0";
export var checkboxCardSelected = "_az-3";
export var disabled = "_az-1";
export var outerBorder = "_az-2";
export var spacerMedium = "_az-7";
export var spacerSmall = "_az-6";
export var spacerXsmall = "_az-5";